;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();import { cva, type VariantProps } from "class-variance-authority";
import type { LucideIcon } from "lucide-react";
import type * as React from "react";

import { cn } from "@/lib/utils";

const emptyStateVariants = cva(
	cn(
		"flex flex-col items-center justify-center text-center p-8 rounded-lg [&_button]:min-w-36",
		"data-[state=error]:**:data-[slot=empty-state-icon-wrapper]:bg-destructive/10 data-[state=error]:**:data-[slot=empty-state-icon]:text-destructive/90",
		"data-[state=success]:**:data-[slot=empty-state-icon-wrapper]:bg-success/20 data-[state=success]:**:data-[slot=empty-state-icon]:text-success",
		"data-[state=warning]:**:data-[slot=empty-state-icon-wrapper]:bg-orange/20 data-[state=warning]:**:data-[slot=empty-state-icon]:text-orange",
	),
	{
		defaultVariants: {
			size: "default",
			variant: "default",
		},
		variants: {
			size: {
				default: "py-12 px-4",
				lg: "py-16 px-6",
				sm: "py-8 px-4",
			},
			variant: {
				card: "bg-card border shadow-sm",
				default: "bg-muted/50",
				transparent: "",
			},
		},
	},
);

export interface EmptyStateProps
	extends React.ComponentPropsWithRef<"div">,
		VariantProps<typeof emptyStateVariants> {
	icon?: LucideIcon;
	iconClassName?: string;
	title?: string;
	description?: string;
	children?: React.ReactNode;
}

const EmptyState = ({
	className,
	variant,
	size,
	icon: Icon,
	iconClassName,
	title,
	description,
	children,
	ref,
	...props
}: EmptyStateProps) => {
	return (
		<div
			className={cn(emptyStateVariants({ size, variant }), className)}
			ref={ref}
			{...props}
		>
			{Icon && (
				<div
					className="mb-4 rounded-full bg-muted p-3"
					data-slot="empty-state-icon-wrapper"
				>
					<Icon
						aria-hidden="true"
						className={cn("size-6 text-muted-foreground", iconClassName)}
						data-slot="empty-state-icon"
					/>
				</div>
			)}
			{title && (
				<h3
					className="text-lg font-medium leading-tight"
					data-slot="empty-state-title"
				>
					{title}
				</h3>
			)}
			{description && (
				<p
					className="text-sm text-muted-foreground mt-1 max-w-md"
					data-slot="empty-state-description"
				>
					{description}
				</p>
			)}
			{children && (
				<div className="mt-4" data-slot="empty-state-content">
					{children}
				</div>
			)}
		</div>
	);
};
EmptyState.displayName = "EmptyState";

export { EmptyState, emptyStateVariants };
